import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Hidden } from "@mui/material";
import TopBar from "./TopBar";
import { FlowSideBar } from "./SideBar";
import { ContentWrapper } from "../../components/ContentWrapper";
import { AuthCircle } from "../../components/AuthCircle";

const drawerWidth = 256;

export const FlowLayout = (): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <TopBar onMobileNavOpen={handleDrawerToggle} elevation={0} />
      <FlowSideBar
        drawerWidth={drawerWidth}
        openMobile={mobileOpen}
        onMobileClose={handleDrawerToggle}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: {
            md: 3,
            sm: 2,
            xs: 2,
          },
          pl: {
            md: 4,
            sm: 2,
            xs: 2,
          },
          width: { md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <ContentWrapper>
          <>
            <Hidden mdDown>
              <AuthCircle />
            </Hidden>
            <Outlet />
          </>
        </ContentWrapper>
      </Box>
    </Box>
  );
};
